import { render, staticRenderFns } from "./AlertsTable.vue?vue&type=template&id=1cff55d7"
import script from "./AlertsTable.vue?vue&type=script&lang=js"
export * from "./AlertsTable.vue?vue&type=script&lang=js"
import style0 from "./AlertsTable.vue?vue&type=style&index=0&id=1cff55d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports